import Preferences from '../js/preferences.js';
import Attendance from '../js/attendance.js';
import EventBus from '../js/event-bus.js';
import moment from 'moment';

var requestManager = {
  EVENTS_LOADED: 'request_manager:events_loaded',
  API_RESPONSE: 'request_manager:api_request',
  // getSetupUrl: function(initCode) { return requestManager.API_URL + 'terminals/' + initCode + '/enable'; },
  getSetupUrl: function(initCode) {
    return requestManager.API_URL + 'terminals/'+initCode.pass+'/enable';
  },
  getEventsUrl: function() { return requestManager.API_URL + 'logentries/xlastofemployee/'+ Preferences.getUser().id; },
  getTagsUrl:   function() { return requestManager.API_URL + 'terminals/leave/reasons/all'; },
  getPostAttendanceUrl: function() { return requestManager.API_URL + 'logentries'; },

  initialize: function() {
    EventBus.$onError(requestManager.API_RESPONSE, requestManager.onApiResponseError);
  },

  getEvents: function(onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', requestManager.getEventsUrl());
    requestManager.prepareXHR(xhr);
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        EventBus.$emit(requestManager.API_RESPONSE, xhr);
        var attendances = Attendance.processArray(JSON.parse(xhr.response));
        if (typeof onSuccess !== 'undefined' && onSuccess !== null) onSuccess(attendances);
        Preferences.setAttendances(attendances);
        Preferences.setAttendancesFetchedAt(moment());
        EventBus.$emit(requestManager.EVENTS_LOADED, attendances);
      } else {
        EventBus.$emitError(requestManager.API_RESPONSE, xhr);
        if (typeof onError !== 'undefined' && onError !== null) onError(xhr);
        EventBus.$emitError(requestManager.EVENTS_LOADED, xhr);
      }
    };
    xhr.send();
  },
  submitAttendance: function(data, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', requestManager.getPostAttendanceUrl());
    requestManager.prepareXHR(xhr, true);
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        EventBus.$emit(requestManager.API_RESPONSE, xhr);
        if (typeof onSuccess !== 'undefined' && onSuccess !== null) onSuccess(xhr);
      } else {
        EventBus.$emitError(requestManager.API_RESPONSE, xhr);
        if (typeof onError !== 'undefined' && onError !== null) onError(xhr);
      }
    };
    xhr.send(JSON.stringify({attendances: [data]}));
  },
  getTags: function(onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', requestManager.getTagsUrl());
    requestManager.prepareXHR(xhr);
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        EventBus.$emit(requestManager.API_RESPONSE, xhr);
        Preferences.setTags(JSON.parse(xhr.response));
        if (typeof onSuccess !== 'undefined' && onSuccess !== null) onSuccess(JSON.parse(xhr.response));
      } else {
        EventBus.$emitError(requestManager.API_RESPONSE, xhr);
        if (typeof onError !== 'undefined' && onError !== null) onError(xhr);
      }
    };
    xhr.send();
  },
  setup: function(initCode, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    xhr.open('PATCH', requestManager.getSetupUrl(initCode));
    xhr.timeout = 30000;
    xhr.setRequestHeader("Frekr-User-Agent", "Frekr/2.0.0");
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        var response = JSON.parse(xhr.response);
        Preferences.setApiKey(btoa(response.user + ':' + response.pass));
        Preferences.setUser({
          id: response.id,
          name: response.username
        });
        Preferences.setCompany({
          id: response.company_id,
          name: response.companyname
        });
        onSuccess(xhr);
      } else {
        onError(xhr);
      }
    };
    xhr.send();
  },
  prepareXHR: function(xhr, setContentTypeJson) {
    xhr.timeout = 30000;
    if (typeof setContentTypeJson == 'undefined') setContentTypeJson = false;
    if (setContentTypeJson) xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    xhr.setRequestHeader("Authorization", "Basic " + Preferences.getApiKey());
    xhr.setRequestHeader("Frekr-User-Agent", "Frekr/2.0.0");
  },

  // TODO this class probably isn't best place for this
  AUTH_ERROR: "auth:error",
  onApiResponseError: function(xhr) {
    // PWA app was probably removed by company admin from user's account
    if (xhr.status === 401) EventBus.$emit(requestManager.AUTH_ERROR, xhr);
  }
}
// requestManager.SERVER_URL = 'http://preview.frekr.me';
requestManager.SERVER_URL = '';
requestManager.API_URL = requestManager.SERVER_URL + '/api/';

export default requestManager;
